var rich_content_viewer_default = {
  "fontElementMap": "hHMVY",
  "wrapper": "SEdCE",
  "pluginContainerMobile": "YDyfr",
  "viewer": "rlG47",
  "android": "rOynt",
  "rootedTraversedContent": "cnG8h",
  "atomic": "My5JI",
  "toolbar": "a4lQ9",
  "block": "BTEV2"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
